export default __webpack_public_path__ + "static/media/DropDownLogo.65d0e0ad.svg";